module.exports = __webpack_public_path__ + "img/logo.69865a10.png";